import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import InsuranceListing from "./InsuranceListing/InsuranceListing";
import InsuranceListingRevamp from "./InsuranceListingRevamp/InsuranceListingRevamp";
import InsuranceListingV2 from "./InsuranceListingV2/InsuranceListingV2";
import {
  InsuranceListingWrapperProps,
  ListingPageProps,
  ListingPageV2Props,
  ListingRevampProps,
} from "./types";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { ListingPageV2 } from "@tm/static";

const InsuranceListingWrapper = ({
  listingRevamp = true,
  onLoginRequest,
  ...props
}: InsuranceListingWrapperProps & { onLoginRequest?: () => void }) => {
  const partner = getPartnerOnClientSide();
  const device = useBreakpointV2();

  if(partner === PARTNER.MYPARTNER && device === "sm") {
    return (
      <ListingPageV2
        payload={(props as ListingPageV2Props).listingData}
        onLoginRequest={onLoginRequest}
      />
    );
  }

  if (partner === PARTNER.MYPARTNER) {
    return <InsuranceListingV2 {...(props as ListingPageV2Props)} />;
  }

  if (listingRevamp) {
    if(device === "sm") {
      return (
        <ListingPageV2
          payload={(props as ListingPageV2Props).listingData}
          onLoginRequest={onLoginRequest}
        />
      );
    }
    return (
      <InsuranceListingRevamp
        {...(props as ListingRevampProps)}
        onLoginRequest={onLoginRequest}
      />
    );
  }

  return (
    <InsuranceListing listingData={(props as ListingPageProps).listingData} />
  );
};

export default InsuranceListingWrapper;
